import { ChevronRight } from "@mui/icons-material";
import { Button } from "@mui/material";

const NextButton = ({ sx, onClick, disabled = false }) => {
  return (
    <Button
      disabled={disabled}
      onClick={() => {
        onClick && onClick();
        window.scrollTo(0, 0);
      }}
      variant="contained"
      size="large"
      endIcon={<ChevronRight />}
      sx={{
        background: `linear-gradient(90deg, #1DA7A7 0%, #0F7A6D 100%)`,
        order: { xs: 2, sm: 1 },
        ...sx,
      }}
    >
      Next
    </Button>
  );
};

export default NextButton;
